import { render, staticRenderFns } from "./bulkInsertIcon.vue?vue&type=template&id=ade03b4e"
import script from "./bulkInsertIcon.vue?vue&type=script&lang=js"
export * from "./bulkInsertIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports